/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Ambienttemperature1Inputs */



/**
* | output |
* | --- |
* | "Ambient temperature - Thermostat(s)" |
*
* @param {Br_History_Key_Ambienttemperature1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_ambienttemperature1 = /** @type {((inputs?: Br_History_Key_Ambienttemperature1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Ambienttemperature1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ambient temperature - Thermostat(s)")
	return /** @type {LocalizedString} */ ("Température d’ambiance - Tête(s) th.")
});
export { br_history_key_ambienttemperature1 as "br_history_key_ambientTemperature" }